import { SxProps } from '@mui/material';
import { OpenSansFontWeights } from 'shared/custom/constants/commonConstants';

export const catalogEntryListCompareCollectorDiagnosticLinkSX: SxProps = {
	fontWeight: OpenSansFontWeights.regular,
	color: 'grey.300',
	display: 'block',
	textDecoration: 'none',
	'&:hover': {
		textDecoration: 'underline',
	},
};
